import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export function Error(props) {
  const {
    errors,
    property,
    index,
  } = props;

  const filteredErrors = useMemo(() => {
    if (!_.isEmpty(property)) {
      return _.filter(errors, error => error.Property === property &&
        (index === error.Index || (index === -1 && error.Index === undefined)));
    }
    return errors;
  }, [errors, index, property]);

  return filteredErrors && filteredErrors.length > 0 ? (
    <div
      role="alert"
      className="errors"
    >
      { _.map(filteredErrors, (error, key) => (
        <div className="error" key={key}>
          {error.Message || error.Code}
        </div>
      ))}
    </div>
  ) : null;
}

Error.propTypes = {
  errors: PropTypes.arrayOf({
    Code: PropTypes.string,
    Message: PropTypes.string,
    Property: PropTypes.string,
    Index: PropTypes.number,
  }),

  property: PropTypes.string,

  index: PropTypes.number,
};

Error.defaultProps = {
  errors: [],
  property: null,
  index: -1,
};
